import React from 'react'
import {colors} from "../../utils/styles"

export class DigitalBigRadio extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
        <div style={{
          fontSize: '16px',
          fontWeight: 700,
          color: colors.mocText,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
             onClick={this.props.onClick}
        >
          <img src={'images/' + (this.props.selected ? 'moc-bradio-selected.svg' : 'moc-bradio.svg')}
               style={{}}/>
          <div style={{width: 10}}/>
          {this.props.label}
        </div>
    )
  }
}

export default DigitalBigRadio